<div class="loader-container" *ngIf="isLoading">
  <div class="loader"></div>
</div>
<h2 *ngIf="!hasAccess" class="no-permission-message">
  {{ 'D6' | translate: locale }}
</h2>
<div class="flex-row flex-direction-column" *ngIf="!isLoading && selectedDashboard && hasAccess">

  <app-title [country]="selectedDashboard.getPayerCountry()" [cpaName]="selectedDashboard.getCpaName() || ''"
    [cpaCode]="selectedDashboard.getCpaKey()" [productGroups]="productGroups" [locale]="locale"
    (productGroupSelected)="onProductGroupSelected($event)">
  </app-title>

  <div class="flex-row margin-bottom-2">
    <div class="flex-row-item">
      <div>
        <div class="discount-period period">
          <span
            *ngIf="selectedDashboard.getReviewFlag() === 'Y' && selectedDashboard.getDiscountStartDate() && selectedDashboard.getDiscountEndDate()">
            {{ selectedDashboard.getDiscountStartDate() | moment : 'D MMM' : locale }} - {{
            selectedDashboard.getDiscountEndDate() | moment : 'D MMM YYYY' : locale }}
          </span>
          <span
            *ngIf="selectedDashboard.getReviewFlag() === 'N' && selectedDashboard.getActiveInitialDiscountPeriodFlag() === 'Y'">
            {{ selectedDashboard.getInitialDiscountStartDate() | moment : 'D MMM' : locale }} - {{
            selectedDashboard.getInitialDiscountEndDate() | moment : 'D MMM YYYY' : locale }}
          </span>
          <span
            *ngIf="selectedDashboard.getReviewFlag() === 'N' && selectedDashboard.getActiveRampUpPeriodFlag() === 'Y'">
            {{ selectedDashboard.getRampUpStartDate() | moment : 'D MMM' : locale }} - {{
            selectedDashboard.getRampUpEndDate() | moment : 'D MMM YYYY' : locale }}
          </span>
        </div>
        <div class="font-color-grey" *ngIf="selectedDashboard.getReviewFlag() === 'Y'">
          {{ 'D7' | translate: locale }}
        </div>
        <div class="font-color-grey"
          *ngIf="selectedDashboard.getReviewFlag() === 'N' && selectedDashboard.getActiveInitialDiscountPeriodFlag() === 'Y'">
          {{ 'D8' | translate: locale }}
        </div>
        <div class="font-color-grey"
          *ngIf="selectedDashboard.getReviewFlag() === 'N' && selectedDashboard.getActiveRampUpPeriodFlag() === 'Y'">
          {{ 'D9' | translate: locale }}
        </div>

        <div class="font-color-grey"
          *ngIf="selectedDashboard.getReviewFlag() === 'N' && selectedDashboard.getActiveRampUpPeriodFlag() === 'N' && selectedDashboard.getActiveInitialDiscountPeriodFlag() === 'N'">
          {{ 'D10' | translate: locale }}
        </div>
        <div class="billing-period-info">
          {{ 'D11' | translate : locale : placeholders }}
        </div>
      </div>
    </div>
    <div class="flex-row-item">
      <div>
        <div class="text-align-right period">
          {{ date | moment : 'D MMM YYYY' : locale }}
        </div>
        <div class="text-align-right font-color-grey">
          {{ 'D12' | translate: locale }}
        </div>
      </div>
    </div>
  </div>


  <div class="flex-row margin-y-2 summary-charts no-page-break">
    <div class="flex-row-item center">
      <app-gauge-chart [currentValue]="currentDiscountPercent" [locale]="locale" [data]="thresholdChartData"
        *ngIf="thresholdChartData?.length">
      </app-gauge-chart>
    </div>
    <div class="flex-row-item">
      <app-short-threshold-chart [dashboard]="selectedDashboard" [data]="thresholdChartData" [locale]="locale"
        *ngIf="thresholdChartData?.length">
      </app-short-threshold-chart>
    </div>
    <div class="dashboard-labels">
      <div class="margin-top-1" *ngIf="currentDiscountPercent >= 0 && revenueCount >= 0">
        <span [innerHTML]="'D17' | translate : locale : placeholders"
          *ngIf="(selectedDashboard.getMeasurementPeriod() ?? 1) === 1"></span>
        <span [innerHTML]="'D17a' | translate : locale : placeholders"
          *ngIf="(selectedDashboard.getMeasurementPeriod() ?? 1) > 1"></span>
      </div>
      <div class="margin-top-1">
        <span [innerHTML]="'D18' | translate : locale : placeholders"></span>
      </div>
      <div class="margin-top-1">
        <span [innerHTML]="'D19' | translate : locale : placeholders"></span>
      </div>
      <div class="font-color-red margin-top-2">
        <div class="generate-rate-card"
          *ngIf="selectedDashboard.getCpaKey() && !isRateCardGenerating && !isRateCardGenerated">
          <a (click)="onGenerateRateCard()">
            <span class="icon"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
            {{ 'D43' | translate: locale }}
          </a>
        </div>
        <div class="font-color-grey"
          *ngIf="selectedDashboard.getCpaKey() && isRateCardGenerating && !isRateCardGenerated">
          <span class="icon"><i class="fa fa-spinner fa-pulse" aria-hidden="true"></i></span>
          {{ 'D44' | translate: locale }}
        </div>
        <div class="generate-rate-card"
          *ngIf="selectedDashboard.getCpaKey() && !isRateCardGenerating && isRateCardGenerated && !isRateCardDownloading">
          <a (click)="onDownloadRateCard(rateCard.getId())">
            <span class="icon"><i class="fa fa-download" aria-hidden="true"></i></span>
            {{ 'D45' | translate: locale }}
          </a>
        </div>
        <div class="font-color-grey"
          *ngIf="selectedDashboard.getCpaKey() && !isRateCardGenerating && isRateCardGenerated && isRateCardDownloading">
          <span class="icon"><i class="fa fa-spinner fa-pulse" aria-hidden="true"></i></span>
          {{ 'D49' | translate: locale }}
        </div>
        <div *ngIf="showQualifyingRevenueLink">
          <a routerLink="/revenue" [queryParams]="measurementQueryParams">
            <span class="icon"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
            {{ 'D20' | translate: locale }}
          </a>
        </div>
        <div *ngIf="showDiscountedShipmentsLink">
          <a routerLink="/shipment" [queryParams]="discountQueryParams">
            <span class="icon"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
            {{ 'D21' | translate: locale }}
          </a>
        </div>
        <div>
          <a routerLink="/event" [queryParams]="eventQueryParams">
            <span class="icon"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
            {{ 'D22' | translate: locale }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="dashboard-labels margin-y-2 printable no-page-break">
    <div class="margin-top-1" *ngIf="currentDiscountPercent >= 0 && revenueCount >= 0">
      <span [innerHTML]="'D17' | translate : locale : placeholders"
        *ngIf="(selectedDashboard.getMeasurementPeriod() ?? 1) === 1"></span>
      <span [innerHTML]="'D17a' | translate : locale : placeholders"
        *ngIf="(selectedDashboard.getMeasurementPeriod() ?? 1) > 1"></span>
    </div>
    <div class="margin-top-1">
      <span [innerHTML]="'D18' | translate : locale : placeholders"></span>
    </div>
    <div class="margin-top-1">
      <span [innerHTML]="'D19' | translate : locale : placeholders"></span>
    </div>
    <div class="font-color-red margin-top-2">
      <div class="generate-rate-card"
        *ngIf="selectedDashboard.getCpaKey() && !isRateCardGenerating && !isRateCardGenerated">
        <a (click)="onGenerateRateCard()">
          <span class="icon"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
          {{ 'D43' | translate: locale }}
        </a>
      </div>
      <div class="font-color-grey"
        *ngIf="selectedDashboard.getCpaKey() && isRateCardGenerating && !isRateCardGenerated">
        <span class="icon"><i class="fa fa-spinner fa-pulse" aria-hidden="true"></i></span>
        {{ 'D44' | translate: locale }}
      </div>
      <div class="generate-rate-card"
        *ngIf="selectedDashboard.getCpaKey() && !isRateCardGenerating && isRateCardGenerated && !isRateCardDownloading">
        <a (click)="onDownloadRateCard(rateCard.getId())">
          <span class="icon"><i class="fa fa-download" aria-hidden="true"></i></span>
          {{ 'D45' | translate: locale }}
        </a>
      </div>
      <div class="font-color-grey"
        *ngIf="selectedDashboard.getCpaKey() && !isRateCardGenerating && isRateCardGenerated && isRateCardDownloading">
        <span class="icon"><i class="fa fa-spinner fa-pulse" aria-hidden="true"></i></span>
        {{ 'D49' | translate: locale }}
      </div>
      <div *ngIf="showQualifyingRevenueLink">
        <a routerLink="/revenue" [queryParams]="measurementQueryParams">
          <span class="icon"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
          {{ 'D20' | translate: locale }}
        </a>
      </div>
      <div *ngIf="showDiscountedShipmentsLink">
        <a routerLink="/shipment" [queryParams]="discountQueryParams">
          <span class="icon"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
          {{ 'D21' | translate: locale }}
        </a>
      </div>
      <div>
        <a routerLink="/event" [queryParams]="eventQueryParams">
          <span class="icon"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
          {{ 'D22' | translate: locale }}
        </a>
      </div>
    </div>
  </div>

  <div class="margin-y-2 no-page-break">
    <div class="border-bottom-2-red sub-title">{{ 'D23' | translate: locale }}</div>
    <div class="margin-top-2">
      <app-timeline-chart [dashboard]="selectedDashboard" [locale]="locale">
      </app-timeline-chart>
    </div>
  </div>

  <div class="margin-y-2 no-page-break">
    <div class="border-bottom-2-red flex-row">
      <div class="flex-row-item">
        <div class="sub-title">{{ 'D27' | translate: locale }}</div>
      </div>

      <div class="flex-row-item last-data-load">
        <div>
          <span class="font-color-grey">{{ 'D28' | translate: locale }} </span>
          <span *ngIf="selectedDashboard.getReportDtm(); else notAvailable">
            {{ selectedDashboard.getReportDtm() | moment : 'D MMM YYYY' : locale }}
          </span>
        </div>
      </div>
    </div>

    <div class="hint">
      {{ 'D29' | translate: locale }}
    </div>
    <div class="flex-row margin-top-2 not-printable-history">
      <div class="flex-row-item">
        <app-history-chart (reviewSelected)="onReviewSelected($event)" [dashboard]="selectedDashboard"
          [reviews]="reviews" [discountTiersAndValues]="discountTiersAndValues" [locale]="locale" [printable]="false"
          [canvas]="{ height: 277, width: 830 }">
        </app-history-chart>
      </div>
      <div class="flex-row-item margin-top-half">
        <app-arrow-chart [dashboard]="selectedDashboard" [review]="selectedReview" [locale]="locale">
        </app-arrow-chart>
      </div>
    </div>
    <div class="flex-row margin-top-2 printable-history">
      <div class="flex-row-item">
        <app-history-chart (reviewSelected)="onReviewSelected($event)" [dashboard]="selectedDashboard"
          [reviews]="reviews" [discountTiersAndValues]="discountTiersAndValues" [locale]="locale" [printable]="true"
          [canvas]="{ height: 277, width: 650 }">
        </app-history-chart>
      </div>
      <div class="flex-row-item margin-top-half">
        <app-arrow-chart [dashboard]="selectedDashboard" [review]="selectedReview" [locale]="locale">
        </app-arrow-chart>
      </div>
    </div>
  </div>


  <div class="margin-y-2 no-page-break">
    <div class="border-bottom-2-red sub-title">{{ 'D37' | translate: locale }}</div>
    <div class="margin-top-2">
      <app-long-threshold-chart [dashboard]="selectedDashboard" [data]="thresholdChartData" [locale]="locale"
        *ngIf="thresholdChartData?.length">
      </app-long-threshold-chart>
    </div>
  </div>

</div>

<div *ngIf="!isLoading && cpas && !selectedDashboard">
  <app-title [locale]="locale"></app-title>
  <div class="breadcrumb font-color-grey">{{ 'D5' | translate: locale }}</div>
  <div class="font-color-red margin-top-2">
    <div *ngFor="let cpa of cpas">
      <i class="fa fa-chevron-right" aria-hidden="true"></i>
      <a routerLink="/dashboard" [queryParams]="{cpa: cpa}">
        {{ cpa }}
      </a>
    </div>
  </div>
</div>

<ng-template #notAvailable>{{ 'D10' | translate: locale }}</ng-template>